import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import { Store } from '@ngrx/store';
import { FormControlState, SetValueAction } from 'ngrx-forms';
import { dateValueConverter } from '@macs-frontend/features/shared';
import { numberConverter } from '@macs-frontend/features/shared/utils/number.converter';

@Component({
  selector: 'md-table-filter-text',
  templateUrl: 'table-filter-text.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['table-filter-text.component.scss'],
})
export class TableFilterTextComponent extends BaseComponent {
  @Output() selected = new EventEmitter();
  // @ts-expect-error
  @Input() ngrxFormControl: FormControlState<any>;

  @Input() number = false;

  show = false;
  readonly dateValueConverter = dateValueConverter;

  constructor(readonly cdr: ChangeDetectorRef, readonly store$: Store) {
    super();
    // makeSelectable(this, { cdr, store$ });
  }

  showFilter() {
    this.show = true;
  }

  hideFilter() {
    this.show = false;
  }

  onClearClick() {
    this.store$.dispatch(new SetValueAction(this.ngrxFormControl.id, null));
    this.selected.emit();
    this.cdr.markForCheck();
  }

  emitSelected() {
    this.selected.emit();
  }

  readonly numberConverter = numberConverter;
}
